<template>
<section>
    <v-select placeholder="Location" @input="changeLocation" label="name" :options="locations.items" style="position:absolute;right:0;top:0;min-width:200px;" class="inline-block ml-2" />

    <div v-if="summaryData.summary">
        <div class="vx-row mt-4">
            <div class="vx-col w-full lg:w-1/3 mb-base">
                <div style="flex-direction:column;justify-content:flex-start;align-items:flex-start;height:100%" class="vx-card bg-primary-gradient flex p-6" slot="no-body">
                    <div class="rounded-full h-16 w-16 flex items-center justify-center rounded-full text-primary shadow" style="background:#ffffff;font-size:34px;letter-spacing:-.5px">{{ summaryData.summary.checkedin }}</div>
                    <h4 class="text-white mt-2">People currently Signed In</h4>
                    <h6 class="text-white mt-2" v-if="summaryData.summary.dependants > 0">Including {{ summaryData.summary.dependants }} dependents</h6>
                    <p class="text-grey ml-2 mt-2">
                        <small>
                            <span v-for="(type, index) in summaryData.summary.contactTypes" :key="index">{{ `${type.count || 0} ${type.name}` }}<span v-if="index > 0"> | </span></span>
                        </small>
                    </p>
                </div>
            </div>

            <div class="vx-col w-full lg:w-2/3 mb-base">
                <statistics-card-line class="overflow-visible" ref="graph" icon="UsersIcon" :statistic="summaryData.summary.visitors || 0" statisticTitle="Visitors Today" :chartData="graphData" type="area"></statistics-card-line>
            </div>
        </div>
    </div>
    <Visits ref="visit" class="mt-5" @load="onLoad"></Visits>
</section>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue';
import Visits from '@/views/dashboard/components/Visits';
import vSelect from 'vue-select';
import {
    mapState
} from 'vuex';
export default {
    components: {
        Visits,
        StatisticsCardLine,
        vSelect
    },
    data() {
        return {
            summaryData: {},
            graphData: {
                series: [
{
                        name: 'Signed In',
                        data: []
                    },
                    {
                        name: 'Sign Ins',
                        data: []
                    },
                    {
                        name: 'Sign Outs',
                        data: []
                    }
                ],
                chartOptions: {
                    colors: ['#2B418B', '#8893b9', '#775858'],
                    grid: {
                        show: false,
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    chart: {
                        toolbar: {
                            show: false
                        },
                        sparkline: {
                            enabled: true
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'smooth',
                        width: 2.5
                    },
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shadeIntensity: 0.9,
                            opacityFrom: 0.5,
                            opacityTo: 0.2,
                            stops: [0, 80, 100]
                        }
                    },
                    xaxis: {
                        type: 'datetime',
                        lines: {
                            show: false
                        },
                        axisBorder: {
                            show: false
                        },
                        labels: {
                            show: false
                        },
                        categories: []
                    },
                    yaxis: [
{
                        y: 0,
                        offsetX: 0,
                        offsetY: 0,
                        padding: {
                            left: 0,
                            right: 0
                        }
                    }
],
                    tooltip: {
                        style: {
                            fontSize: '10px'
                        },
                        x: {
                            formatter: val => {
                                return this.$options.filters.shortDate(val);
                            }
                        }
                        // y: {
                        //   formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
                        //     return 'tesr'
                        //   }
                        // },
                        // custom: function({series, seriesIndex, dataPointIndex, w}) {
                        //   return '<div class="arrow_box">' +
                        //     '<span>' + series[seriesIndex][dataPointIndex] + '</span>' +
                        //     '</div>'
                        // }
                    }
                }
            }
        }
    },
    computed: {
        ...mapState('visitManagement', ['locations'])
    },
    methods: {
        onLoad(data) {
            this.summaryData = data;
            this.$nextTick(() => {
                const activity = this.summaryData.activity || [];
                const dataSeries = this.graphData.series;
                const checkedIn = dataSeries[0];
                const signIns = dataSeries[1];
                const signOuts = dataSeries[2];
                const xAxisTime = this.graphData.chartOptions.xaxis.categories;
                checkedIn.data = [];
                signIns.data = [];
                signOuts.data = [];

                const pushItemToDataSeries = item => {
                    checkedIn.data.push(item.checkedIn);
                    signIns.data.push(item.checkins);
                    signOuts.data.push(item.checkouts);
                    xAxisTime.push(item.time);
                };

                let skip = true;
                for (let i = 0; i < activity.length; i++) {
                    const item = activity[i];
                    if (!(item.checkins === 0 && item.checkouts === 0)) skip = false;
                    if (!skip) pushItemToDataSeries(item);
                }

                console.log(dataSeries)

                // this.$refs.graph.$refs.apexChart.loadGraph();
                this.$refs.graph.$refs.apexChart.refresh()

            })
        },
        async changeLocation(value) {
            await this.$refs.visit.changeLocation(value)
        }
    },
    async created() {
        await this.$store.dispatch('visitManagement/fetchLocations', {
            limit: 10000
        });
    }
}
</script>
